import { call, put } from 'redux-saga/effects';
import { requestUapiHarvestEvents } from '../../requesters/harvestRequester/uapiHarvestRequester';
import { StoreCrops } from '../../types/Crop';
import { receiveHarvestMetadata } from '../../actions/harvestActions';
import { HarvestEvents } from '../../types';
import { HarvestYield } from '../../types/HarvestYield';
import { logDmbError } from '../../utils/error';

export interface RetrieveHarvestDataParams {
  fieldUUID: string;
  cropsMap: StoreCrops;
}

export interface HarvestDataRetrieved {
  harvestSeasons: {season: string}[];
  events: {
    [season: string]: HarvestYield;
  };
}

export function* retrieveHarvestData({ fieldUUID, cropsMap }: RetrieveHarvestDataParams) {
  try {
    const response: HarvestEvents = yield call(requestUapiHarvestEvents, fieldUUID, cropsMap);

    yield put(receiveHarvestMetadata(Object.values(response.events)));

    const dataRetrieved: HarvestDataRetrieved = {
      ...response,
      harvestSeasons: response.harvestSeasons.map(season => ({season})),
    }
    
    return dataRetrieved;
  } catch (error) {
    logDmbError(error, {
      fieldUUID
    });
  }

  return {
    harvestSeasons: [],
    events: {},
  };
}
